import { render, staticRenderFns } from "./FormSubmissions.vue?vue&type=template&id=59f42bf6&scoped=true&"
import script from "./FormSubmissions.vue?vue&type=script&lang=js&"
export * from "./FormSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./FormSubmissions.vue?vue&type=style&index=0&id=59f42bf6&scoped=true&lang=css&"
import style1 from "./FormSubmissions.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f42bf6",
  null
  
)

export default component.exports